/**
 * Big Waster API
 * This is a Big Waster API.
 *
 * OpenAPI spec version: 1.0
 * Contact: terry.wong@futureimpactlab.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 *
 */

import ApiClient from '../ApiClient';

/**
 * The ScheduleCreateScheduleParam model module.
 * @module model/ScheduleCreateScheduleParam
 * @version 1.0
 */
class ScheduleCreateScheduleParam {
    /**
     * Constructs a new <code>ScheduleCreateScheduleParam</code>.
     * @alias module:model/ScheduleCreateScheduleParam
     */
    constructor() { 
        
        ScheduleCreateScheduleParam.initialize(this);
    }

    /**
     * Initializes the fields of this object.
     * This method is used by the constructors of any subclasses, in order to implement multiple inheritance (mix-ins).
     * Only for internal use.
     */
    static initialize(obj) { 
    }

    /**
     * Constructs a <code>ScheduleCreateScheduleParam</code> from a plain JavaScript object, optionally creating a new instance.
     * Copies all relevant properties from <code>data</code> to <code>obj</code> if supplied or a new instance if not.
     * @param {Object} data The plain JavaScript object bearing properties of interest.
     * @param {module:model/ScheduleCreateScheduleParam} obj Optional instance to populate.
     * @return {module:model/ScheduleCreateScheduleParam} The populated <code>ScheduleCreateScheduleParam</code> instance.
     */
    static constructFromObject(data, obj) {
        if (data) {
            obj = obj || new ScheduleCreateScheduleParam();

            if (data.hasOwnProperty('date')) {
                obj['date'] = ApiClient.convertToType(data['date'], 'String');
            }
            if (data.hasOwnProperty('orgId')) {
                obj['orgId'] = ApiClient.convertToType(data['orgId'], 'Number');
            }
            if (data.hasOwnProperty('userId')) {
                obj['userId'] = ApiClient.convertToType(data['userId'], 'Number');
            }
        }
        return obj;
    }


}

/**
 * @member {String} date
 */
ScheduleCreateScheduleParam.prototype['date'] = undefined;

/**
 * @member {Number} orgId
 */
ScheduleCreateScheduleParam.prototype['orgId'] = undefined;

/**
 * @member {Number} userId
 */
ScheduleCreateScheduleParam.prototype['userId'] = undefined;






export default ScheduleCreateScheduleParam;

